import { useDispatch, useSelector } from 'react-redux';
import { useEffectOnce } from 'usehooks-ts';

import { useRouteParam, useParseParams } from '@hooks/params';
import { findPersonalAccidentQuoteParamsSchema } from '@apis/PersonalAccidentQuoteApi';

import { personalAccidentQuoteFetch, PersonalAccidentQuoteFetchPayload, personalAccidentQuoteFind, PersonalAccidentQuoteFindPayload } from './action';
import { selectPersonalAccidentQuoteBuyRoute } from './selector';
import { PersonalAccidentQuoteBuyNewPageParams } from './route';

export const usePersonalAccidentQuoteBuyNewPageParams = () =>
  useParseParams<PersonalAccidentQuoteBuyNewPageParams>(findPersonalAccidentQuoteParamsSchema);

export const usePersonalAccidentQuoteFind = () => {
  const dispatch = useDispatch();
  const params = usePersonalAccidentQuoteBuyNewPageParams();
  const { personalAccidentQuote } = useSelector(selectPersonalAccidentQuoteBuyRoute);
  useEffectOnce(() => {
    const payload: PersonalAccidentQuoteFindPayload = params;
    dispatch(personalAccidentQuoteFind(payload));
  });
  return personalAccidentQuote;
};

export const usePersonalAccidentQuoteFetch = () => {
  const orderNumber = useRouteParam('orderNumber') as string;
  const dispatch = useDispatch();
  const { personalAccidentQuote } = useSelector(selectPersonalAccidentQuoteBuyRoute);
  useEffectOnce(() => {
    const payload: PersonalAccidentQuoteFetchPayload = { orderNumber };
    dispatch(personalAccidentQuoteFetch(payload));
  });
  return personalAccidentQuote;
};
